import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BlacklistEntry, CreateBlacklistRequest } from '../interfaces/blacklist.interface';
import { ApiResponse } from '../interfaces/api.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanyUserBlacklistService {
  private baseUrl = '/api/company/users';

  constructor(private http: HttpClient) {}

  getAll(userId: number, page = 1, limit = 50): Observable<ApiResponse<BlacklistEntry[]>> {
    return this.http.get<ApiResponse<BlacklistEntry[]>>(
      `${this.baseUrl}/${userId}/blacklist?page=${page}&limit=${limit}`
    );
  }

  create(userId: number, data: CreateBlacklistRequest): Observable<ApiResponse<BlacklistEntry>> {
    return this.http.post<ApiResponse<BlacklistEntry>>(`${this.baseUrl}/${userId}/blacklist`, data);
  }

  toggleActive(userId: number, entryId: number): Observable<ApiResponse<BlacklistEntry>> {
    return this.http.patch<ApiResponse<BlacklistEntry>>(
      `${this.baseUrl}/${userId}/blacklist/${entryId}/toggle-active`, {}
    );
  }

  delete(userId: number, entryId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${userId}/blacklist/${entryId}`);
  }
}
